<p-dialog appDialogoPadrao="pi pi-map-marker" descricao="Restringe o relatório à abrangência da delegacia." [(visible)]="visible" [style]="{ width: '520px' }" header="Buscar Delegacia (Abrangência)" (onShow)="onShow()">
    <p-table [value]="delegacias()" [scrollable]="true" scrollHeight="280px" [loading]="carregando()" selectionMode="single" [selection]="selecionada()" (selectionChange)="selecionar($event)" dataKey="id" [ariaLabel]="'Tabela de delegacias'">
        <ng-template pTemplate="header">
            <tr>
                <th>Delegacia</th>
                <th style="width: 70px">UF</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
            <tr [pSelectableRow]="row" [pSelectableRowIndex]="rowIndex" (dblclick)="selecionar(row); confirmar()">
                <td>{{ row.delegacia }}</td>
                <td>{{ row.uf }}</td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="2" style="text-align: center">
                    @if (!uf()) {
                        Selecione uma UF na aba Prestador antes de buscar a delegacia.
                    } @else {
                        Nenhuma delegacia encontrada.
                    }
                </td>
            </tr>
        </ng-template>
    </p-table>

    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" label="Confirmar" (onClick)="confirmar()" [disabled]="!selecionada()" [loading]="validando()" />
        <p-button icon="pi pi-times" label="Cancelar" severity="secondary" (onClick)="cancelar()" />
    </ng-template>
</p-dialog>
